import { IconProps } from '@/common/types/general';
import { css } from './IconAIGenius.css';

interface IIconAIGeniusProps extends IconProps {
  colored?: boolean;
  loading?: boolean;
}

export function IconAIGenius({
  width = 50,
  height = 50,
  className,
  colored = true,
  loading,
}: IIconAIGeniusProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      fill="none"
      viewBox="0 0 50 50"
      className={className}
    >
      <circle
        cx="25"
        cy="25"
        r="25"
        fill={colored ? 'url(#icon-ai-genius-a)' : 'currentColor'}
      />
      <g className={loading ? css.pathGroup : ''}>
        <path
          fill={colored ? '#C4E8E4' : '#FFFFFF'}
          className={loading ? css.pathLeft : ''}
          d="M25.895 36.607a10.714 10.714 0 1 1 0-21.429V36.607Z"
        />
        <path
          fill={colored ? '#FFE5D8' : '#FFFFFF'}
          className={loading ? css.pathRight : ''}
          d="M27.677 11.607a8.928 8.928 0 1 1 0 17.857V11.606Z"
        />
      </g>
      <defs>
        <linearGradient
          id="icon-ai-genius-a"
          x1="0"
          x2="50"
          y1="0"
          y2="50"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FE7165" />
          <stop offset="1" stopColor="#FF8D78" />
        </linearGradient>
      </defs>
    </svg>
  );
}
